import { ReelInit, SymbolObject, SYMBOLS_PER_REEL_FEATURE } from "./ReelInit";

import { Group /*, Easing*/, Tween } from "tweedle.js";

import { getSymbol } from "../config/getSymbol";
import {
    REEL_NUMBERS,
    SYMBOL_HEIGHT
} from "../config/reelConfig";

import { sound } from "@pixi/sound";
import { isQuickBtnOnGlobal, isSuperQuickBtnOnGlobal } from "../config/GlobalVariableConfig";
import { GameConstants } from '../gameClientEvents/GameConstants';
import { spinData } from "../server/getServerResposesFun";
import { BLANK_SYM_ID } from "./ReelInit";

const reelTweenGroup = new Group();

// const POS_MOVE_TIME = 150;



export class ReelSpin extends ReelInit {


    constructor() {
        super();



    }


    public updateReelSpin(): void {

        Group.shared.update();
        reelTweenGroup.update();

    }

    private generateMovingSteps(reelSymbolsMatrix: number[][]): { movingSteps: number[][]; isAnticipationPlay: boolean } {

        const REEL_NUMBERS = 5;
        const SYMBOLS_PER_REEL = 8;

        let isAnticipationPlay = false;

        const movingSteps: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL).fill(0)
        );

        const blankSymbols: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
            Array(SYMBOLS_PER_REEL).fill(-1)
        );

        let startVal = 5;
        let blankSymbolCount = 0;
        let reelStepOffset = 0;


        //checking for only 5x5 grid
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            let reelHasBlank = false;

            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                if (reelSymbolsMatrix[reelNum][posNum] === BLANK_SYM_ID) {
                    reelHasBlank = true;

                    const steps = startVal + (isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal ? 0 : reelStepOffset);
                    blankSymbolCount++;
                    blankSymbols[reelNum][posNum] = blankSymbolCount;
                    movingSteps[reelNum][posNum] = steps;
                } else {
                    movingSteps[reelNum][posNum] = 0;
                }
            }

            // Only increment for reels that have at least one blank
            if (reelHasBlank && !(isSuperQuickBtnOnGlobal || isQuickBtnOnGlobal)) {
                reelStepOffset += 2;
            }
        }

        // till this point moving setps has been counted in array movingSteps


        // now we will see if additional moving is required for ancipation
        // for this check which are the last 3 cells to spin; for that use the array lastBlankSymbols


        //after the reelspin presentation the total count of coins
        const currentCoinCount = reelSymbolsMatrix.flat().filter(v => v !== BLANK_SYM_ID).length;
        console.log("currentCoinCount", currentCoinCount);

        const maxSymbolsPerGrid = 40;
        if (currentCoinCount >= (maxSymbolsPerGrid - 2)) {

            isAnticipationPlay = true

            const lastBlankSymbols = Array.from({ length: REEL_NUMBERS }, () =>
                Array(SYMBOLS_PER_REEL).fill(0)
            );

            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {

                    if (blankSymbols[reelNum][posNum] != -1 && (blankSymbolCount - blankSymbols[reelNum][posNum] < 8)) {
                        lastBlankSymbols[reelNum][posNum] = 1;
                    }
                }

            }


            // this.topReelGridAnticipationOn();
            let incrementValue = 10; // start from +10

            for (let i = 0; i < REEL_NUMBERS; i++) {
                for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                    if (lastBlankSymbols[i][j] === 1) {
                        movingSteps[i][j] += incrementValue;
                        incrementValue += 10; // next +10
                    }
                }
            }
        }

        console.log("movingSteps movingSteps", movingSteps);
        console.log("movingSteps blankSymbols", blankSymbols);

        return { movingSteps, isAnticipationPlay };
    }



    private spinLeft: number = -1;

    private meterPrefix = "multi_respin";

    public async startReels(currentRespinIndex: number): Promise<void> {

        const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
        this.winCollectionMeter.visible = false;

        if (this.spinLeft == -1) { // first time appear

            this.duplicateInitialReel(currentRespinIndex - 1);

            this.spinLeft = 3;

            this.spinLeftMeter.visible = true;


            this.spinLeftMeter.state.setAnimation(0, "multi_respin_appear", false).listener = {
                complete: () => {
                    if (this.spinLeft == 4) {
                        this.spinLeftMeter.state.setAnimation(0, "extra_respin_4_appear", false);
                        this.meterPrefix = "extra_respin";
                        setTimeout(() => {
                            sound.play("extra_spin_awarded", { volume: 1 });
                        }, 300);
                        // sound.play("extra_spin_awarded");
                    }
                    this.spinLeftMeter.state.clearListeners();
                }
            };
            this.spinLeftMeter.state.timeScale = timeScale;



        }

        await new Promise(resolve => setTimeout(resolve, 1000));

        if (this.spinLeft > 0)
            this.spinLeftMeter.state.setAnimation(0, `${this.meterPrefix}_${this.spinLeft}_out`, false)


        // this.spinLeftMeter.state.timeScale = timeScale;

        this.spinLeft = this.spinLeft - 1;
        // Manager.casinoChannelHandler.reportUpdateFeatureCounter(this.spinLeft);

        const reelSymbolsMatrix: number[][] = this.prevReelSymbols;

        let movingSteps: number[][] = [];
        let isTopAnticipationPlay = false;



        const { movingSteps: movingStepsTop, isAnticipationPlay: isTopAnticipationPlayLocal } = this.generateMovingSteps(reelSymbolsMatrix);

        movingSteps = movingStepsTop;
        isTopAnticipationPlay = isTopAnticipationPlayLocal;



        if (isTopAnticipationPlay) {
            // this.topReelGridAnticipationOn();
        }



        console.log("inside startReels hold and spin", currentRespinIndex, reelSymbolsMatrix);


        this.prevReelSymbols = spinData.respins[currentRespinIndex].reelSymbols;



        sound.play('reels_spinning', { loop: true, volume: 0.5 });
        const promises: Promise<void>[] = [];

        for (let i = 0; i < reelSymbolsMatrix.length; i++) {
            for (let j = 0; j < reelSymbolsMatrix[i].length; j++) {

                if (reelSymbolsMatrix[i][j] == BLANK_SYM_ID) {
                    const repeatCount = movingSteps[i][j];
                    const promise = this.moveSymbolRepeatedly(currentRespinIndex, this.allReelArray[i].symbols[j], repeatCount, i, j).then(() => console.log(`Done: ${i}, ${j}`));
                    promises.push(promise);
                }

            }
        }

        await Promise.all(promises);
        sound.stop('reels_spinning');
        sound.play('reel_stop');

        //await this.awardMultipliersToCoin(currentRespinIndex);

        if (spinData.respins[currentRespinIndex].featureData?.coinInfo.spinLeft != null) {
            const spinLeftBackend = spinData.respins[currentRespinIndex].featureData?.coinInfo.spinLeft.value;

            if (spinData.respins[currentRespinIndex].featureData?.coinInfo.spinLeft.isReduceSpins == false /*&& this.spinLeft < spinLeftBackend*/) {

                const timeScale = isSuperQuickBtnOnGlobal ? 2 : 1;
                this.spinLeftMeter.state.setAnimation(0, `${this.meterPrefix}_${this.spinLeft}_in`, false);
                this.spinLeftMeter.state.timeScale = timeScale;

                // sound.play("spin_meter_refill", { volume: 1, speed: timeScale });

                // Manager.casinoChannelHandler.reportUpdateFeatureCounter(spinLeftBackend);
            }

            this.spinLeft = spinLeftBackend;

        }

        // await this.allReelStop();
    }

    private duplicateInitialReel(currentRespinIndex: number) {

        const initialCoinValues = spinData.respins[currentRespinIndex].featureData?.coinInfo.initialCoinValues || [];
        const initialSymbols = spinData.respins[currentRespinIndex].reelSymbols;

        for (let i = 0; i < initialCoinValues.length; i++) {
            for (let j = 0; j < initialCoinValues[i].length; j++) {

                if (this.prevReelSymbols[i][j] == BLANK_SYM_ID && initialCoinValues[i][j] > 0) {

                    const finalMultVal = initialCoinValues[i][j];

                    // const finalSymbolId = 12; // gold coin's id
                    const finalSymbolId = initialSymbols[i][j];

                    const symbolObj = this.allReelArray[i].symbols[j];
                    const indexInView = 1 - symbolObj.IdxCellOffView;

                    symbolObj.cells[indexInView].symbolId = finalSymbolId;
                    symbolObj.cells[indexInView].coinVal = finalMultVal;

                    this.addReelSymbolsToContainer(i, j);

                }
            }

        }

    }


    private async moveSymbolRepeatedly(currentRespinIndex: number, symbolObj: SymbolObject, count: number, reelNum: number, posNum: number): Promise<void> {

        let finalSymbolId = spinData.respins[currentRespinIndex].reelSymbols[reelNum][posNum];
        let finalMultVal = spinData.respins[currentRespinIndex].featureData?.coinInfo.coinValues[reelNum][posNum] || 0;

        const randSymIds = [40, 25, 26, 27, 28, 13, 14, 40, 40, 27, 40, 40, 13, 14, 40, 40, 29, 40, 13, 40, 40]; // blank and gold coin symbol ids for random display during spin

        // turn on the alpha of top symbol ( above the mask )
        symbolObj.cells[symbolObj.IdxCellOffView].symbol.alpha = 1;

        for (let i = 0; i < count; i++) {

            // texture swap

            const indexOffView = symbolObj.IdxCellOffView;
            const symbol = symbolObj.cells[indexOffView].symbol;
            const coinValText = symbolObj.cells[indexOffView].coinValText;


            if (i == count - 1) { // final move

                symbol.texture = getSymbol(finalSymbolId, true);

                if (finalSymbolId >= GameConstants.GOLD_COIN_START_SYMBOL_ID && finalSymbolId <= GameConstants.GRAND_SYMBOL_ID) { // normal gold coin's id
                    coinValText.text = `X${finalMultVal}`;
                }
            }
            else {
                const randId = randSymIds[Math.floor(Math.random() * randSymIds.length)];
                symbol.texture = getSymbol(randId, true);
                coinValText.text = "";
            }

            await this.moveSymbol(symbolObj);

            const indexInView = 1 - symbolObj.IdxCellOffView;

            symbolObj.cells[indexInView].symbolId = finalSymbolId;
            symbolObj.cells[indexInView].coinVal = finalMultVal;
            // if (i == count - 1) {
            //     console.log("IdxCellInView y", symbolObj.cells[indexInView].view.y)
            // }
        }

        if (finalSymbolId != BLANK_SYM_ID) {
            this.addReelSymbolsToContainer(reelNum, posNum);
            // sound.play('coin_appear_sound', { volume: 1 });
        }
        else {
            // sound.play('reel_stop');
        }

        // change the alpha of top symbol ( above the mask to 0)
        symbolObj.cells[symbolObj.IdxCellOffView].symbol.alpha = 0;

    }



    private async moveSymbol(symbolObj: SymbolObject): Promise<void> {
        return new Promise<void>((resolve) => {
            let currentVal = 0;
            const targetVal = 1;

            new Tween({ x: currentVal })
                .to({ x: targetVal }, isSuperQuickBtnOnGlobal ? 100 : 200)
                .onUpdate((obj) => {
                    currentVal = obj.x;

                    for (let i = 0; i < symbolObj.cells.length; i++) {
                        const isVisible = i === symbolObj.IdxCellOffView;
                        symbolObj.cells[i].view.y = (isVisible ? -SYMBOL_HEIGHT : 0) + currentVal * SYMBOL_HEIGHT;
                    }
                })
                .onComplete(() => {
                    // reelTweenGroup.remove(tween);

                    // Reset positions
                    for (let i = 0; i < symbolObj.cells.length; i++) {
                        symbolObj.cells[i].view.y = (i === symbolObj.IdxCellOffView ? 0 : -SYMBOL_HEIGHT);
                    }

                    // Flip view index
                    symbolObj.IdxCellOffView = 1 - symbolObj.IdxCellOffView;

                    resolve();
                })
                .start();
        });
    }

    // private multiplierValues: number[][] = Array.from({ length: REEL_NUMBERS }, () =>
    //     Array(SYMBOLS_PER_REEL_FEATURE).fill(0)
    // );
    //@ts-ignore
    private async awardMultipliersToCoin(currentRespinIndex: number): Promise<void> {

        const multiplierValues = spinData.respins[currentRespinIndex].featureData?.coinInfo?.multiplierValues;

        if (multiplierValues == null || multiplierValues == undefined) {
            return Promise.resolve();
        }


        return new Promise(async (resolve) => {

            const animationPromises: Promise<void>[] = [];

            this.totalWinVal = 0;

            for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
                for (let posNum = 0; posNum < SYMBOLS_PER_REEL_FEATURE; posNum++) {

                    // console.log("inside awardMultipliersToCoin", reelNum, posNum, this.reelOverlaySymbols[reelNum][posNum]);

                    const multVal = multiplierValues[reelNum][posNum]

                    if (multVal > 0) {

                        const animationPromise = this.addMultToCoinInContainer(reelNum, posNum, multVal);
                        animationPromises.push(animationPromise);

                        await new Promise(resolve => setTimeout(resolve, 500));

                    }
                }
            }



            if (animationPromises.length > 0) {
                await Promise.all(animationPromises);
                resolve();
            }
            else {
                resolve();
            }

        })
    }





}
